import React, { Component, useEffect, useRef, useState } from 'react';
import { Container, Row, Col, FormControl, Table, Image, Dropdown, DropdownButton, Form, Button, Pagination, ButtonToolbar, OverlayTrigger, Tooltip, Modal } from 'react-bootstrap';
import { Spinner } from 'react-activity';
import moment from 'moment';
import PdfIcon from '../../Images/pdf-receipt.svg'
import FormatMoney from '../../Helpers/formatMoney';
import BackArrow from '../../Images/arrow-left.svg';
import { ReactComponent as Check } from '../../Images/check-correct-blue.svg'
import ReactPaginate from 'react-paginate';
import { TemplatePdf } from './component/templatePdf';
import Backend from '../../Backend';
import Connection from '../../Calls';
import Flecha from '../../Images/flecha.svg'
import translate from '../../translate';

export default function Transactions (props){
    const { services, ecomm, General } = props.traductions
    const values = ['Wallet','Servicio','Label', 'Status','Amount', 'MXN_Amount', 'Date','Reference', 'Receipt']
    const [TransactionList, setTransactionList] = useState([])
    const [SortedList, setSortedList] = useState([])
    const [sort, setSort] = useState(services.transactions.filtros.dateNew)
    const [search, setSearch] = useState('')

    const [pageCount, setPageCount] = useState(0);
    const [itemOffset, setItemOffset] = useState(0);
    const [currentItems, setCurrentItems] = useState([]);
    const itemsPerPage = 6;
    useEffect(() => {
        getTransaction()
    }, [])

    useEffect(() => {
        sortArray()
    }, [sort,search,TransactionList])

    useEffect(() => {
        // Fetch items from another resources.
        const endOffset = itemOffset + itemsPerPage;
        setCurrentItems(SortedList.slice(itemOffset, endOffset));
        setPageCount(Math.ceil(SortedList.length / itemsPerPage));
      }, [itemOffset, itemsPerPage, SortedList]);



    const getTransaction = () => {
        const self = this
        let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
        navigator.geolocation.getCurrentPosition((success, error, options) => {
        latitude = success.coords.latitude;
        longitude = success.coords.longitude
        });
        result = latitude + longitude;
        Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {

            Backend.get_transactions_list(response.payload.r01, response=>{
                setTransactionList(response.payload.payments?.reverse()||[])

            })

        })
    }

    const handleRowData = (elementObj) => {
        TemplatePdf(elementObj)
    }

    const renderDate = () => {
        let date=moment().utc()
        return `${date.get('day')} / ${General.months[date.get('month')+1]} / ${date.get('year')}`
    }

    const renderHeaders = () =>{
        return values.map(item => {
        return(
            <th style={ item === 'Receipt' ? {textAlign: 'center', border:0} : {border:0}} className='gray-text'>
                {services.transactions.header[item] === 'MXN Amount' ? 'Fiat Amount' : services.transactions.header[item]}
            </th>
        )
        });
    }
    const renderLst = () => {
        if(currentItems.length > 0){
            return currentItems.map((item)=>{
                return(
                    <tr>
                        <td >
                            <Image src={require("../../CryptoIcons/" + item.coin + ".svg")} style={{ height: 20,marginRight: 5}} />
                            {item.wallet}
                        </td>
                        <td>{item.service}</td>
                        <td>{item.label}</td>
                        <td >{item.status}</td>
                        <td>{item.amount}</td>
                        <td>{FormatMoney(item.currency_amount)} {item.currency_coin.toUpperCase()}</td>
                        <td>{item.date}</td>
                        {
                            item.authorization === '-1' ?
                            <td><p className='container_transactions_text_invalid'>{services.transactions.dataCopies.invalidReference}</p></td>
                            : 
                            <td>{item.authorization}</td>
                        }
                        <td style={{textAlign: 'center'}}>
                            {item.status === 'approved' && <Image onClick={() => handleRowData(item)} className="btn-download-pdf" src={PdfIcon} width={40} height={40}/>}
                        </td>
                        {/*<td>
                            <OverlayTrigger placement="auto-end" delay={{ show: 250, hide: 400 }} overlay={<Tooltip id="button-tooltip-2">{item.txid}</Tooltip>}>
                                <div className='elipsisi'>{item.txid}</div>
                            </OverlayTrigger>
                        </td>*/}
                    </tr>
                )
            })
        }
    }

    const sortArray = () => {
        let array = TransactionList;
        if(search!='')
        array = array.filter( i =>
            i.service.toLowerCase().indexOf(search.toLowerCase()) != -1 ||
            i.coin.toLowerCase().indexOf(search.toLowerCase()) != -1 ||
            i.wallet.toLowerCase().indexOf(search.toLowerCase()) != -1 ||
            i.status.toLowerCase().indexOf(search.toLowerCase()) != -1

        );
        console.log(TransactionList);

        switch (sort) {
            // case services.transactions.filtros.dateNew:
            //     array = TransactionList
            //     break;
            case services.transactions.filtros.dateOld:
                array = array.slice().reverse()
                break;
            case services.transactions.filtros.servicio:
                array = array.slice().sort(function(a, b){
                    if(a.service < b.service) { return -1; }
                    if(a.service > b.service) { return 1; }
                    return 0;
                })
                break;
            case services.transactions.filtros.status:
                array= array.slice().sort(function(a, b){
                    if(a.status < b.status) { return -1; }
                    if(a.status > b.status) { return 1; }
                    return 0;
                })
                break;
            default:
                break;
        }
        setSortedList(array);
    }

    const renderSortOptions = () => {
        let values = ['servicio','status','dateNew','dateOld']
        return values.map((item)=>{
            return (
                <>
                    <Dropdown.Item onClick={()=>{setSort(services.transactions.filtros[item])}} as="button">
                        {services.transactions.filtros[item]}
                    </Dropdown.Item>
                </>
            )
        })

    }

      const handlePageClick = (event) => {
        const newOffset = (event.selected * itemsPerPage) % SortedList.length;
        console.log(
          `User requested page number ${event.selected}, which is offset ${newOffset}`
        );
        setItemOffset(newOffset);
    };

    return(
        <Container className="services_transactiosn_container" style={{ paddingLeft: 10, paddingRight: 10 }}>
        <div>
            <div className='back-button' style={{ cursor:'pointer', marginTop:-15, marginBottom:10, display:'flex', alignItems:'center'}} onClick={()=>props.goBack()}>
            <Image src={BackArrow} style={{ marginTop:-3, marginRight:10}}/>
            <p className='dark-text medium-dms text-25' style={{margin:0}}>{services.transactions.title}</p>
            </div>
        </div>

        <div className='container-transactions'>
            <div style={{width:'100%', display:'flex', justifyContent:'flex-end', alignItems:'flex-end'}}>
                <Col md={3} className='virtual_exchange_dropdown'>
                    <Form.Label className="dark-text normal-dms font-17 bmargin0"> {services.transactions.filtros.title} :</Form.Label>
                    <Dropdown title={sort}>
                    <Dropdown.Toggle id="dropdown-custom-1">
                        {
                        sort
                        }
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                        {renderSortOptions()}
                    </Dropdown.Menu>
                    </Dropdown>
                </Col>
                <Col md={3} className='virtual_exchange_dropdown'>
                    <Form.Control
                        style={{ height: 40 }}
                        className="input-services"
                        type="text"
                        placeholder="Buscar"
                        value={search}
                        onChange={(e)=>setSearch(e.target.value)}
                    />
                </Col>
            </div>

            <div style={{width:'100%', height:1, backgroundColor:'#D7E4FC', marginTop:'1em', marginBottom:'1em'}}/>

            <div className='container-transactions-table'>
                <Table >
                    <thead>
                        <tr>
                            {renderHeaders()}
                        </tr>
                    </thead>
                    <tbody>
                        {renderLst()}
                    </tbody>
                </Table>
                <div style={{display:'flex', justifyContent:'center', alignItems:'flex-end'}}>
                    <ReactPaginate
                        breakLabel="..."
                        nextLabel={<Image src={Flecha} style={{ marginRight: 5, width: 10 }} />}
                        onPageChange={handlePageClick}
                        pageRangeDisplayed={5}
                        pageCount={pageCount}
                        previousLabel= {<Image src={Flecha} style={{ marginRight: 5, width: 10, transform:'scaleX(-1)' }} />}
                        renderOnZeroPageCount={null}
                        activeClassName="active"
                    />
                </div>
            </div>
        </div>
        </Container>
    )
}
